<template>
  <div class="left-panel blur-bg"
       :class="`${leftPanel ? 'left-panel-open' : ''}`">
    <div class="left-panel-switch"
         @click="SetLeftPanelStatus()">
    </div>
    <app-menu :isMenuOpen="leftPanel" />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import AppMenu from '@views/components/Menu/index.vue'

export default {
  components: {
    AppMenu,
  },
  computed: {
    ...mapState({
      leftPanel: state => state.app.leftPanel,
    }),
  },
  methods: {
    ...mapActions(['SetLeftPanelStatus']),
  },
}
</script>


<style lang="scss">
@import '@src/styles/variables.scss';

.left-panel {
  width: 48px;
  height: 100%;
  transition: width 0.3s;
  padding: 15px;
  position: relative;
  z-index: 1;
}
.left-panel-switch {
  width: 20px;
  height: 15px;
  border: 3px solid #fff;
  border-width: 3px 0;
  padding: 3px 0;
  background-clip: content-box;
  background-color: #fff;
  cursor: pointer;
}
.left-panel-open {
  width: 180px;
  min-width: 180px;
}
</style>
